import { client, isUserProcessLoading } from 'core/selectors';
import { connect } from 'react-redux';
import ConfirmationModal from '../../../components/clients/ConfirmationModal';

export default connect(
    state => ({
        isUserProcessLoading: isUserProcessLoading(state),
        client: client(state)
    }),
    {},
)(ConfirmationModal);
